import produce from "immer";
import React, { FC, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { uuid } from "uuidv4";
import {
  startAddCell,
  startCopyRow,
  startEditElement,
} from "../../../../actions/elementListAction";
import { Element } from "../../../../models/elementModel";
import { TabelHeading } from "../../../../models/tabelHeading";
import { TableRowModel } from "../../../../models/tableRowModel";
import { getSession } from "../../../../selectors/appSelectors";
import { SystemTypes } from "../../../../utils/constants";
import TableHeading from "./tableHeading";
import TableRowElement from "./tableRowElement";
import { Tooltip } from "react-tippy";
import '../Remarks.scss';

export interface TableElementProps {
  index: string;
  element: Element;
  isPreview?: boolean;
}

const TableElement: FC<TableElementProps> = ({ index, element, isPreview = false }) => {
  const dispatch = useDispatch();
  const sessionState = useSelector(getSession);
  const [viewRemark, setViewRemark] = useState(sessionState.viewRemark);

  const [open, setIsOpen] = useState(false);

  useEffect(() => {
    setViewRemark(sessionState.viewRemark)
    console.log(sessionState.viewRemark)

  }, [sessionState])

  const addCellAction = () => {
    dispatch(startAddCell(element));
  };

  const copyRowAction = async (lastRow: TableRowModel, rowIndex: number) => {
    dispatch(startCopyRow(element, lastRow, rowIndex, isPreview));
  };

  const defaultStyle = {
    marginTop: element.properties.isMarginAll
      ? element.styles.margin + "px"
      : element.styles.marginTop + "px",
    marginRight: element.properties.isMarginAll
      ? element.styles.margin + "px"
      : element.styles.marginRight + "px",
    marginBottom: element.properties.isMarginAll
      ? element.styles.margin + "px"
      : element.styles.marginBottom + "px",
    marginLeft: element.properties.isMarginAll
      ? element.styles.margin + "px"
      : element.styles.marginLeft + "px",
    textAlign: element.styles.textAlign,
  };
  //custome css - start
  const styleList = element.properties.cssStyles;

  const styleObj: { [key: string]: any } = {};

  for (let index = 0; index < styleList.length; index++) {
    styleObj[styleList[index].retrivedStyle] = styleList[index].value;
  }
  //custome css - end

  //custome Heading css -start
  const headingStyleList = element.properties.headingCssStyles;

  const headingStyleObj: { [key: string]: any } = {};
  if (headingStyleList !== undefined) {
    for (let index = 0; index < headingStyleList.length; index++) {
      headingStyleObj[headingStyleList[index].retrivedStyle] = headingStyleList[index].value;
    }
  }

  //custome Heading css -end

  //custome table body css -start
  const tbodyStyleList = element.properties.tbodyCssStyles;

  const tbodyStyleObj: { [key: string]: any } = {};
  if (tbodyStyleList !== undefined) {
    for (let index = 0; index < tbodyStyleList.length; index++) {
      tbodyStyleObj[tbodyStyleList[index].retrivedStyle] = tbodyStyleList[index].value;
    }
  }

  //custome table body css -end
  return (
    <div key={index} style={{ ...defaultStyle }}>
      <Tooltip title={element.properties.tooltip}>
        <table
          className={`table ${element.properties.tableTheme}`}
          style={{
            height:
              element.styles.height === "" ||
              element.styles.height === "0" ||
              element.styles.height === undefined
                ? ""
                : element.styles.height + "px",
            width:
              element.styles.width === "" ||
              element.styles.width === "0" ||
              element.styles.width === undefined
                ? ""
                : element.styles.width + "px",
            fontSize:
              element.styles.fontSize === "" ||
              element.styles.fontSize === undefined ||
              element.styles.fontSize === "0"
                ? ""
                : element.styles.fontSize + "px",
            color: element.styles.color,
            backgroundColor: element.styles.backgroundColor,
            ...styleObj,
          }}
        >
          <thead
            className={element.properties.headingTheme}
            style={{
              display: element.properties.displayHeader ? "" : "none",
              ...headingStyleObj,
            }}
          >
            <tr>
              {element.properties.headings.map((heading: TabelHeading) => {
                return (
                  <TableHeading
                    heading={heading}
                    elementId={element.id}
                    sectionId={element.sectionId}
                    formId={element.formId}
                    tableTheam={element.properties.tableTheme}
                  />
                );
              })}
              {!isPreview &&
                sessionState.selectedType === SystemTypes.ELEMENT &&
                sessionState.selectedElementId === element.id && (
                  <th
                    style={{
                      borderBottom:
                        element.properties.tableTheme === "table-borderless" ||
                        element.properties.tableTheme === undefined ||
                        element.properties.tableTheme === ""
                          ? "0px"
                          : "",
                      borderTop:
                        element.properties.tableTheme === "table-borderless" ||
                        element.properties.tableTheme === undefined ||
                        element.properties.tableTheme === ""
                          ? "0px"
                          : "",
                    }}
                  >
                    <i
                      onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        addCellAction();
                      }}
                      className="fa fa-plus"
                    ></i>
                  </th>
                )}
            </tr>
          </thead>
          <tbody style={{ ...tbodyStyleObj }}>
            {element.properties.rows.map((row: TableRowModel, i: number) => {
              return (
                <TableRowElement
                  index={i}
                  row={row}
                  element={element}
                  isPreview={isPreview}
                />
              );
            })}
          </tbody>
        </table>
        {isPreview && element.properties.displayAddrow && (
          <div className="d-flex justify-content-end">
            <i
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                let number = element.properties.rows.length - 1;
                copyRowAction(element.properties.rows[number], number);
              }}
              className="fa fa-clone"
            ></i>
          </div>
        )}
      </Tooltip>
      {isPreview &&
        viewRemark &&
        (element.properties.remark1 ||
          element.properties.remark2 ||
          element.properties.remark3 ||
          element.properties.remark4) && (
          <Tooltip
            interactive
            open={open}
            onRequestClose={() => setIsOpen(false)}
            html={
              <>
                <h6>Remarks of {element.name}</h6>
                {element.properties.remark1 !== undefined &&
                  element.properties.remark1 !== "" && (
                    <div className="remark">
                      Remark 1 : {element.properties.remark1}
                    </div>
                  )}
                {element.properties.remark2 !== undefined &&
                  element.properties.remark2 !== "" && (
                    <div className="remark">
                      Remark 2 : {element.properties.remark2}
                    </div>
                  )}
                {element.properties.remark3 !== undefined &&
                  element.properties.remark3 !== "" && (
                    <div className="remark">
                      Remark 3 : {element.properties.remark3}
                    </div>
                  )}
                {element.properties.remark4 !== undefined &&
                  element.properties.remark4 !== "" && (
                    <div className="remark">
                      Remark 4 : {element.properties.remark4}
                    </div>
                  )}
                {(element.properties.remark1 === undefined ||
                  element.properties.remark1 === "") &&
                  (element.properties.remark2 === undefined ||
                    element.properties.remark2 === "") &&
                  (element.properties.remark3 === undefined ||
                    element.properties.remark3 === "") &&
                  (element.properties.remark4 === undefined ||
                    element.properties.remark4 === "") && (
                    <div>No Remarks to Display</div>
                  )}
              </>
            }
            position="left"
          >
            <div style={{ textAlign: "end" }}>
              <i
                className="fa fa-info-circle"
                aria-hidden="true"
                onClick={() => {
                  setIsOpen(true);
                }}
              ></i>
            </div>
          </Tooltip>
        )}
    </div>
  );
};

export default TableElement;
